import React, { useState } from 'react';
import { X, Settings as SettingsIcon, RotateCcw } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { toast } from 'sonner';

export const SettingsModal = ({ onClose }) => {
  const { settings, updateSettings, resetSettings } = useSettings();
  const [form, setForm] = useState({ ...settings });

  const save = (e) => {
    e.preventDefault();
    updateSettings({
      clinic_name: form.clinic_name.trim() || settings.clinic_name,
      doctor_name: form.doctor_name.trim() || settings.doctor_name,
      clinic_phone: form.clinic_phone.trim() || settings.clinic_phone,
      clinic_landline: form.clinic_landline.trim() || settings.clinic_landline,
    });
    toast.success('Clinic details updated · changes appear on every screen');
    onClose();
  };

  const reset = () => {
    resetSettings();
    toast('Reset to defaults');
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-6"
      style={{ background: 'rgba(28, 25, 23, 0.55)', backdropFilter: 'blur(8px)' }}
      onClick={onClose}
      data-testid="settings-modal"
    >
      <div
        className="rounded-[var(--radius-2xl)] p-8 w-full max-w-lg animate-slide-up"
        style={{
          background: '#FFFFFF',
          boxShadow: '0 30px 60px rgba(28,25,23,0.20)',
          border: '1px solid rgba(28,25,23,0.06)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full flex items-center justify-center"
                 style={{ background: 'rgba(61, 90, 128, 0.08)' }}>
              <SettingsIcon size={20} strokeWidth={1.75} style={{ color: 'var(--color-slate)' }} />
            </div>
            <div>
              <h2 className="font-['Sora'] text-2xl font-bold" style={{ color: '#1C1917' }}>
                Clinic settings
              </h2>
              <p className="font-['Inter'] text-sm" style={{ color: '#78716C' }}>
                Changes appear on every screen instantly
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 rounded-full glass-subtle flex items-center justify-center hover:bg-[rgba(61,90,128,0.08)] transition-all duration-180"
          >
            <X size={18} strokeWidth={1.75} style={{ color: '#44403C' }} />
          </button>
        </div>

        <form onSubmit={save} className="space-y-5">
          <Field
            label="CLINIC NAME"
            value={form.clinic_name}
            onChange={(v) => setForm({ ...form, clinic_name: v })}
            placeholder="Dr. Priya Nair Clinic"
            testid="settings-clinic-name"
          />
          <Field
            label="DOCTOR NAME"
            value={form.doctor_name}
            onChange={(v) => setForm({ ...form, doctor_name: v })}
            placeholder="Dr. Priya Nair"
            testid="settings-doctor-name"
          />
          <Field
            label="CLINIC PHONE (FOR PATIENT WHATSAPP)"
            value={form.clinic_phone}
            onChange={(v) => setForm({ ...form, clinic_phone: v })}
            placeholder="+91 98765 12345"
            testid="settings-clinic-phone"
          />
          <Field
            label="LANDLINE / CALL NUMBER"
            value={form.clinic_landline}
            onChange={(v) => setForm({ ...form, clinic_landline: v })}
            placeholder="020 4321 5678"
            testid="settings-clinic-landline"
          />

          <div className="flex items-center gap-3 pt-2">
            <button
              type="button"
              onClick={reset}
              className="h-12 px-4 rounded-[var(--radius-lg)] glass-subtle font-['Sora'] text-sm font-semibold flex items-center gap-2 hover:bg-[rgba(28,25,23,0.04)] transition-colors duration-180"
              style={{ color: '#78716C' }}
              data-testid="settings-reset-btn"
            >
              <RotateCcw size={14} strokeWidth={1.75} />
              Reset
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 h-12 rounded-[var(--radius-lg)] glass-subtle font-['Sora'] font-semibold transition-colors duration-180 hover:bg-[rgba(28,25,23,0.04)]"
              style={{ color: '#44403C' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-copper-3d flex-1 h-12 rounded-[var(--radius-lg)] font-['Sora'] font-semibold"
              data-testid="settings-save-btn"
            >
              Save changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const Field = ({ label, value, onChange, placeholder, testid }) => (
  <div>
    <label className="text-overline block mb-2">{label}</label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full glass-subtle rounded-[var(--radius-md)] h-[52px] px-4 font-['Inter'] text-base outline-none"
      style={{ color: '#1C1917' }}
      data-testid={testid}
    />
  </div>
);

export default SettingsModal;
